<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl mb-0">
          Controle de Campanhas WhatsApp
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="campaigns"
              :loading="loading"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Itens por página:',
              }"
              class="elevation-0"
              no-data-text="Nenhuma campanha encontrada"
              loading-text="Carregando dados..."
              item-key="id"
            >
              <!-- Ações -->
              <template #item.actions="{ item }">
                <v-btn
                  icon
                  small
                  color="info"
                  title="Visualizar"
                  @click="openCampaignDetail(item)"
                >
                  <v-icon small>
                    {{ icons.mdiEye }}
                  </v-icon>
                </v-btn>
              </template>
              <!-- Data -->
              <template #item.date="{ item }">
                <div class="d-flex flex-column">
                  <span class="font-weight-medium">{{ formatDate(item.date) }}</span>
                  <span class="text-xs text--secondary">{{ formatTime(item.date) }}</span>
                </div>
              </template>

              <!-- Nome Campanha -->
              <template #item.campaignName="{ item }">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ item.campaignName }}
                </div>
              </template>

              <!-- Usuário -->
              <template #item.userName="{ item }">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ item.userName || '-' }}
                </div>
              </template>

              <!-- Foto de Perfil -->
              <template #item.profileImage="{ item }">
                <div v-if="item.idfileProfileImage" class="d-flex align-center">
                  <v-avatar
                    size="40"
                    class="mr-2 cursor-pointer"
                    @click="downloadImage(item.idfileProfileImage, item.campaignName + '_profile')"
                  >
                    <img
                      :src="getPublicImageUrl(item.idfileProfileImage)"
                      :alt="'Foto de perfil - ' + item.campaignName"
                      @error="handleImageError"
                    >
                  </v-avatar>
                  <a
                    href="#"
                    class="text-decoration-none info--text text-caption"
                    @click.prevent="downloadImage(item.idfileProfileImage, item.campaignName + '_profile')"
                  >
                    <v-icon small>{{ icons.mdiDownload }}</v-icon>
                  </a>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Nome do Perfil -->
              <template #item.profileName="{ item }">
                <div v-if="item.profileName" class="d-flex align-center">
                  <div class="text-truncate" style="max-width: 200px;">
                    {{ item.profileName }}
                  </div>
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    @click="copyToClipboard(item.profileName)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Base -->
              <template #item.base="{ item }">
                <v-chip
                  small
                  color="primary"
                  outlined
                  class="cursor-pointer"
                  @click="downloadContactsCsv(item)"
                >
                  {{ item.quantity || 0 }} contatos
                </v-chip>
              </template>

              <!-- Horário -->
              <template #item.scheduledDate="{ item }">
                <div v-if="item.scheduledDate" class="d-flex flex-column">
                  <span class="font-weight-medium">{{ formatDate(item.scheduledDate) }}</span>
                  <span class="text-xs text--secondary">{{ formatTime(item.scheduledDate) }}</span>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Link da Mídia -->
              <template #item.mediaImage="{ item }">
                <div v-if="item.idFileImageMessage" class="d-flex align-center">
                  <v-avatar
                    size="40"
                    class="mr-2 cursor-pointer"
                    @click="downloadImage(item.idFileImageMessage, item.campaignName + '_media')"
                  >
                    <img
                      :src="getPublicImageUrl(item.idFileImageMessage)"
                      :alt="'Mídia - ' + item.campaignName"
                      @error="handleImageError"
                    >
                  </v-avatar>
                  <a
                    href="#"
                    class="text-decoration-none info--text text-caption"
                    @click.prevent="downloadImage(item.idFileImageMessage, item.campaignName + '_media')"
                  >
                    <v-icon small>{{ icons.mdiDownload }}</v-icon>
                  </a>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Copy -->
              <template #item.messageContent="{ item }">
                <div v-if="item.messageContent" class="d-flex align-center">
                  <div class="text-truncate" style="max-width: 200px;">
                    {{ item.messageContent }}
                  </div>
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    @click="copyToClipboard(item.messageContent)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Link de direcionamento -->
              <template #item.buttonLink="{ item }">
                <div v-if="item.buttonLink" class="d-flex align-center">
                  <a
                    :href="item.buttonLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-decoration-none info--text text-truncate"
                    style="max-width: 150px;"
                  >
                    {{ item.buttonLink }}
                  </a>
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    @click="copyToClipboard(item.buttonLink)"
                  >
                    <v-icon small>{{ icons.mdiContentCopy }}</v-icon>
                  </v-btn>
                </div>
                <span v-else class="text--secondary text-caption">-</span>
              </template>

              <!-- Status do disparo -->
              <template #item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item.status)"
                  small
                  label
                  dark
                >
                  {{ getStatusLabel(item.status) }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de confirmação -->
    <v-dialog
      v-model="confirmDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{ confirmDialogTitle }}
        </v-card-title>
        <v-card-text>
          {{ confirmDialogMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="confirmDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :color="confirmDialogType === 'finalize' ? 'success' : 'error'"
            text
            @click="confirmAction"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de detalhes da campanha -->
    <v-dialog
      v-model="dialogCampaignDetail"
      max-width="800"
    >
      <v-card>
        <v-card-title class="headline">
          Detalhes da campanha
        </v-card-title>
        <v-card-text v-if="selectedCampaign">
          <v-row>
            <v-col cols="12" md="6">
              <p class="mb-1"><strong>Nome da Campanha:</strong></p>
              <p class="mb-3">{{ selectedCampaign.campaignName }}</p>

              <p class="mb-1"><strong>Data:</strong></p>
              <p class="mb-3">{{ formatDate(selectedCampaign.date) }} {{ formatTime(selectedCampaign.date) }}</p>

              <p class="mb-1"><strong>Base:</strong></p>
              <p class="mb-3">{{ selectedCampaign.quantity || 0 }} contatos</p>

            
            </v-col>
            <v-col cols="12" md="6">
              <p class="mb-1"><strong>Copy:</strong></p>
              <p class="mb-3">
                {{ selectedCampaign.messageContent || '-' }}
              </p>

              <p class="mb-1"><strong>Link de direcionamento:</strong></p>
              <p class="mb-3">
                <a
                  v-if="selectedCampaign.buttonLink"
                  :href="selectedCampaign.buttonLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ selectedCampaign.buttonLink }}
                </a>
                <span v-else>-</span>
              </p>
              <p class="mb-1"><strong>Status:</strong></p>
              <v-chip
                :color="getStatusColor(selectedCampaign.status)"
                small
                label
                dark
              >
                {{ getStatusLabel(selectedCampaign.status) }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title v-if="!isCampaignFinished" class="headline">
          Upload do relatório
        </v-card-title>
        <v-card-text v-if="!isCampaignFinished">
          <div class="mt-n2 mb-2">
            <input
              ref="mediaFile"
              type="file"
              accept=".xlsx,.xls,.csv,.docx,.txt,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain"
              hidden
              @change="handleMediaFile"
            />
            <div
              class="drop-zone"
              :class="{ 'drop-zone-active': isDragging }"
              @dragover.prevent="handleDragOver"
              @dragleave.prevent="handleDragLeave"
              @drop.prevent="handleDrop"
            >
              <v-btn
                color="primary"
                outlined
                block
                large
                class="dashed-border media-upload-btn"
                :disabled="mediaLoading"
                @click="$refs.mediaFile.click()"
              >
                <v-icon left>
                  {{ icons.mdiPaperclip }}
                </v-icon>
                {{ isDragging ? 'Solte o arquivo aqui' : 'Clique ou arraste o relatório (Excel, CSV, DOCX ou TXT)' }}
              </v-btn>
            </div>
            
            <!-- Indicador de loading -->
            <div v-if="mediaLoading" class="mt-2 text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                size="20"
              />
              <span class="ml-2">Processando arquivo...</span>
            </div>

            <!-- Preview do arquivo selecionado -->
            <div v-if="mediaFileSelected && !mediaLoading" class="mt-3">
              <v-card outlined class="pa-3">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon :color="getFileTypeColor()" class="mr-2" size="32">
                      {{ getMediaIcon() }}
                    </v-icon>
                    <div>
                      <div class="font-weight-medium">{{ mediaFileName }}</div>
                      <div class="text-caption text--secondary">
                        {{ formatFileSize(mediaFileSelected.size) }} • {{ getFileTypeLabel() }}
                      </div>
                    </div>
                  </div>
                  <v-btn
                    icon
                    small
                    @click="removeMediaFile"
                  >
                    <v-icon small>{{ icons.mdiCancel }}</v-icon>
                  </v-btn>
                </div>
                
                <!-- Preview para arquivos de texto -->
                <div v-if="mediaType === 'txt' || mediaType === 'csv'" class="mt-2">
                  <v-card outlined class="pa-2" style="max-height: 200px; overflow-y: auto;">
                    <pre class="text-caption mb-0" style="white-space: pre-wrap; word-wrap: break-word;">{{ filePreviewContent }}</pre>
                  </v-card>
                </div>
                
                <!-- Preview para outros tipos (mostrar apenas informações) -->
                <div v-else class="mt-2">
                  <v-alert
                    type="info"
                    dense
                    outlined
                  >
                    Arquivo {{ getFileTypeLabel() }} selecionado e pronto para upload
                  </v-alert>
                </div>
              </v-card>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            @click="dialogCampaignDetail = false"
          >
            Fechar
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            contained
            :disabled="!selectedCampaign || !canCancel(selectedCampaign)"
            @click="cancelCampaign(selectedCampaign)"
          >
            Cancelar campanha
          </v-btn>
          <v-btn
            color="success"
            contained
            :disabled="!selectedCampaign || !canFinalize(selectedCampaign)"
            @click="finalizeCampaign(selectedCampaign)"
          >
            Finalizar campanha
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiContentCopy,
  mdiCheckCircle,
  mdiCancel,
  mdiEye,
  mdiDownload,
  mdiFileDocument,
  mdiFileExcel,
  mdiFile,
  mdiFileDocumentOutline,
  mdiPaperclip,
} from '@mdi/js'
import { mapActions, mapState } from 'vuex'


export default {
  name: 'WhatsAppControl',

  data() {
    return {
      icons: {
        mdiContentCopy,
        mdiCheckCircle,
        mdiCancel,
        mdiEye,
        mdiDownload,
        mdiFileDocument,
        mdiFileExcel,
        mdiFile,
        mdiFileDocumentOutline,
        mdiPaperclip,
      },
      loading: false,
      campaigns: [],
      dialogCampaignDetail: false,
      confirmDialog: false,
      confirmDialogTitle: '',
      confirmDialogMessage: '',
      confirmDialogType: '',
      selectedCampaign: null,
      mediaFileSelected: null,
      mediaFileName: '',
      mediaType: '',
      mediaPreviewUrl: '',
      mediaLoading: false,
      isDragging: false,
      filePreviewContent: '',
    }
  },

  computed: {
    headers() {
      return [
        { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '80px' },
        { text: 'Data', value: 'date', align: 'left', sortable: true },
        { text: 'Nome Campanha', value: 'campaignName', align: 'left', sortable: true },
        { text: 'Usuário', value: 'userName', align: 'left', sortable: true },
        { text: 'Foto de Perfil', value: 'profileImage', align: 'center', sortable: false },
        { text: 'Nome do Perfil', value: 'profileName', align: 'center', sortable: true },
        { text: 'Base', value: 'base', align: 'center', sortable: true },
        { text: 'Horário', value: 'scheduledDate', align: 'left', sortable: true },
        { text: 'Link da Mídia', value: 'mediaImage', align: 'center', sortable: false },
        { text: 'Copy', value: 'messageContent', align: 'left', sortable: false },
        { text: 'Link de direcionamento', value: 'buttonLink', align: 'left', sortable: false },
        { text: 'Status do disparo', value: 'status', align: 'center', sortable: true },
      ]
    },
    isCampaignFinished() {
      if (!this.selectedCampaign || !this.selectedCampaign.status) return false
      return ['completed', 'cancelled'].includes(this.selectedCampaign.status)
    },
  },

  watch: {
    dialogCampaignDetail(newValue) {
      if (!newValue) {
        // Limpar campos de upload quando o dialog for fechado
        this.removeMediaFile()
        // Limpar também o input file
        if (this.$refs.mediaFile) {
          this.$refs.mediaFile.value = ''
        }
      }
    },
  },

  async created() {
    await this.fetchCampaigns()
  },

  methods: {
    ...mapActions('serviceWhatsapp', [
      'findAll',
      'finalize',
      'cancel',
    ]),

    async fetchCampaigns() {
      this.loading = true
      try {
        const data = await this.findAll()
        
        // Se o backend retornar um array diretamente
        if (Array.isArray(data)) {
          this.campaigns = data
        } else if (data && Array.isArray(data.campaigns)) {
          // Se o backend retornar um objeto com propriedade campaigns
          this.campaigns = data.campaigns
        } else {
          // Dados mockados para desenvolvimento do frontend (quando backend não estiver pronto)
          this.campaigns = [
            {
              id: 1,
              date: new Date(),
              campaignName: 'Campanha Teste 1',
              idfileProfileImage: 1,
              idFileImageMessage: 2,
              quantity: 5000,
              scheduledDate: new Date(),
              messageContent: 'Mensagem de teste da campanha WhatsApp',
              buttonLink: 'https://example.com',
              status: 'pending',
            },
          ]
        }
      } catch (error) {
        console.error('Erro ao buscar campanhas:', error)
        this.$notify('Erro ao carregar campanhas', 'error')
        // Dados mockados em caso de erro
        this.campaigns = []
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('pt-BR')
    },

    formatTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    getPublicImageUrl(fileId) {
      if (!fileId) return ''
      return `${this.$axios.defaults.baseURL}/public/files/${fileId}`
    },

    async downloadImage(fileId, fileName) {
      try {
        const url = this.getPublicImageUrl(fileId)
        const response = await fetch(url)
        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = `${fileName || 'image'}.${blob.type.split('/')[1] || 'png'}`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
        this.$notify('Imagem baixada com sucesso', 'success')
      } catch (error) {
        console.error('Erro ao baixar imagem:', error)
        this.$notify('Erro ao baixar imagem', 'error')
      }
    },

    handleImageError(event) {
      event.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40"%3E%3Crect width="40" height="40" fill="%23ccc"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3E?%3C/text%3E%3C/svg%3E'
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$notify('Copiado para a área de transferência', 'success')
      }).catch(() => {
        this.$notify('Erro ao copiar link', 'error')
      })
    },

    async downloadContactsCsv(item) {
      if (!item.campaignId) {
        this.$notify('Campanha não possui ID para download', 'error')
        return
      }

      try {
        // Buscar os números de telefone
        const phoneNumbers = await this.$axios.get(
          `whatsapp-campaign/${item.campaignId}/phone-numbers`
        )
        
        if (!phoneNumbers.data || phoneNumbers.data.length === 0) {
          this.$notify('Nenhum contato encontrado para esta campanha', 'warning')
          return
        }
        
        // Criar conteúdo CSV (números um abaixo do outro)
        const csvContent = phoneNumbers.data.join('\n')
        
        // Criar blob e fazer download
        const blob = new Blob([csvContent], { type: 'text/plain;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `contatos-${item.campaignName || item.campaignId}.txt`
        
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        
        this.$notify('Arquivo de contatos baixado com sucesso', 'success')
      } catch (error) {
        console.error('Erro ao baixar contatos:', error)
        this.$notify('Erro ao baixar contatos', 'error')
      }
    },

    getStatusColor(status) {
      const statusMap = {
        pending: 'warning',
        processing: 'info',
        completed: 'success',
        cancelled: 'error',
        failed: 'error',
      }
      return statusMap[status] || 'grey'
    },

    getStatusLabel(status) {
      const statusMap = {
        pending: 'Pendente',
        processing: 'Em processamento',
        completed: 'Finalizada',
        cancelled: 'Cancelada',
        failed: 'Falhou',
      }
      return statusMap[status] || 'Desconhecido'
    },

    openCampaignDetail(campaign) {
      this.selectedCampaign = campaign
      this.dialogCampaignDetail = true
    },

    canFinalize(item) {
      // Permitir finalizar apenas se estiver pendente ou em processamento
      if (!item || !item.status) return false
      return ['pending', 'processing'].includes(item.status)
    },

    canCancel(item) {
      // Permitir cancelar apenas se não estiver finalizada ou cancelada
      if (!item || !item.status) return false
      return !['completed', 'cancelled'].includes(item.status)
    },

    finalizeCampaign(campaign) { 
      this.selectedCampaign = campaign
      this.confirmDialogTitle = 'Finalizar Campanha'
      this.confirmDialogMessage = `Deseja realmente finalizar a campanha "${campaign.campaignName}"?`
      this.confirmDialogType = 'finalize'
      this.confirmDialog = true
    },

    cancelCampaign(campaign) {
      this.selectedCampaign = campaign
      this.confirmDialogTitle = 'Cancelar Campanha'
      this.confirmDialogMessage = `Deseja realmente cancelar a campanha "${campaign.campaignName}"?`
      this.confirmDialogType = 'cancel'
      this.confirmDialog = true
    },

    async confirmAction() {
      if (!this.selectedCampaign) return

      try {
        const reportFile = this.mediaFileSelected || null
        
        if (this.confirmDialogType === 'finalize') {
          const result = await this.finalize({
            campaignId: this.selectedCampaign.id,
            reportFile,
          })
          if (result !== false && result !== null) {
            this.$notify('Campanha finalizada com sucesso', 'success')
          } else {
            this.$notify('Erro ao finalizar campanha', 'error')
            return
          }
        } else if (this.confirmDialogType === 'cancel') {
          const result = await this.cancel({
            campaignId: this.selectedCampaign.id,
            reportFile,
          })
          if (result !== false && result !== null) {
            this.$notify('Campanha cancelada com sucesso', 'success')
          } else {
            this.$notify('Erro ao cancelar campanha', 'error')
            return
          }
        }

        this.confirmDialog = false
        this.dialogCampaignDetail = false
        await this.fetchCampaigns()
      } catch (error) {
        console.error('Erro ao executar ação:', error)
        this.$notify('Erro ao executar ação', 'error')
      }
    },

    handleMediaFile(event) {
      const file = event.target.files[0]
      if (!file) return

      this.mediaLoading = true

      try {
        // Validar tipo de arquivo - aceitar apenas Excel, CSV, DOCX e TXT
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          'application/vnd.ms-excel', // .xls
          'text/csv', // .csv
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
          'text/plain', // .txt
        ]
        
        const allowedExtensions = ['.xlsx', '.xls', '.csv', '.docx', '.txt']
        const fileName = file.name.toLowerCase()
        const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext))
        const hasValidType = allowedTypes.includes(file.type) || file.type === ''

        if (!hasValidExtension && !hasValidType) {
          this.$notify('Por favor, selecione apenas arquivos Excel (.xlsx, .xls), CSV (.csv), DOCX (.docx) ou TXT (.txt)', 'error')
          event.target.value = ''
          this.mediaLoading = false
          return
        }

        // Determinar o tipo de arquivo
        let fileType = 'file'
        if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls') || file.type.includes('spreadsheet') || file.type.includes('excel')) {
          fileType = 'excel'
        } else if (fileName.endsWith('.csv') || file.type === 'text/csv') {
          fileType = 'csv'
        } else if (fileName.endsWith('.docx') || file.type.includes('wordprocessing')) {
          fileType = 'docx'
        } else if (fileName.endsWith('.txt') || file.type === 'text/plain') {
          fileType = 'txt'
        }

        this.mediaFileSelected = file
        this.mediaFileName = file.name
        this.mediaType = fileType
        this.filePreviewContent = ''

        // Ler conteúdo para preview se for arquivo de texto
        if (fileType === 'txt' || fileType === 'csv') {
          const reader = new FileReader()
          reader.onload = (e) => {
            const content = e.target.result
            // Limitar preview a 1000 caracteres para não sobrecarregar
            this.filePreviewContent = content.length > 1000 
              ? content.substring(0, 1000) + '\n\n... (conteúdo truncado)'
              : content
            this.mediaLoading = false
          }
          reader.onerror = () => {
            this.$notify('Erro ao ler arquivo', 'error')
            this.mediaLoading = false
            this.removeMediaFile()
          }
          reader.readAsText(file)
        } else {
          // Para outros tipos, apenas criar URL de preview
          try {
            this.mediaPreviewUrl = URL.createObjectURL(file)
            this.mediaLoading = false
          } catch (error) {
            console.error('Erro ao criar preview:', error)
            this.mediaLoading = false
          }
        }
        
        // Limpar o input para permitir selecionar o mesmo arquivo novamente
        event.target.value = ''
      } catch (error) {
        console.error('Erro ao processar arquivo de mídia:', error)
        this.$notify('Erro ao processar arquivo. Tente novamente.', 'error')
        event.target.value = ''
        this.mediaLoading = false
        this.removeMediaFile()
      }
    },

    removeMediaFile() {
      if (this.mediaPreviewUrl) {
        URL.revokeObjectURL(this.mediaPreviewUrl)
      }
      this.mediaFileSelected = null
      this.mediaFileName = ''
      this.mediaType = ''
      this.mediaPreviewUrl = ''
      this.filePreviewContent = ''
    },

    getMediaIcon() {
      switch (this.mediaType) {
        case 'excel':
          return this.icons.mdiFileExcel
        case 'docx':
          return this.icons.mdiFileDocument
        case 'csv':
        case 'txt':
          return this.icons.mdiFileDocumentOutline
        default:
          return this.icons.mdiFile
      }
    },

    getFileTypeColor() {
      switch (this.mediaType) {
        case 'excel':
          return 'success'
        case 'docx':
          return 'primary'
        case 'csv':
          return 'info'
        case 'txt':
          return 'grey'
        default:
          return 'grey'
      }
    },

    getFileTypeLabel() {
      switch (this.mediaType) {
        case 'excel':
          return 'Excel'
        case 'docx':
          return 'Word'
        case 'csv':
          return 'CSV'
        case 'txt':
          return 'Texto'
        default:
          return 'Arquivo'
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },

    // Funções de drag and drop
    handleDragOver(event) {
      event.preventDefault()
      this.isDragging = true
    },

    handleDragLeave(event) {
      event.preventDefault()
      this.isDragging = false
    },

    handleDrop(event) {
      event.preventDefault()
      this.isDragging = false

      const files = event.dataTransfer.files
      if (files.length > 0) {
        const file = files[0]
        
        // Criar um evento fake para passar para handleMediaFile
        const fakeEvent = {
          target: {
            files: [file],
            value: '',
          },
        }
        
        this.handleMediaFile(fakeEvent)
      }
    },

  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.8;
}


/* Botão com borda tracejada */
.dashed-border {
  border-style: dashed !important;
  border-width: 2px !important;
}

.media-upload-btn {
  min-height: 60px !important;
  height: 60px !important;
}

/* Drop zone */
.drop-zone {
  transition: all 0.3s ease;
}

.drop-zone-active {
  transform: scale(1.02);
  opacity: 0.8;
}

.drop-zone-active .media-upload-btn {
  background-color: rgba(25, 118, 210, 0.1) !important;
  border-color: #1976d2 !important;
  border-width: 3px !important;
}

</style>
